import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import ClientRequestsPage from "@/pages/client/ClientRequestsPage";

export const Route = createFileRoute("/client/contracts/$contractId/requests")({
  head: () => pageHead("Client · Contracts · Requests", "AKIVA client · contracts · requests portal.", "/client/contracts/$contractId/requests", true),
  component: ClientRequestsPage,
});
